// extracted by mini-css-extract-plugin
export default {"title":"PopupSpecialEvent_title__qD34m","description":"PopupSpecialEvent_description__XxSTt","field":"PopupSpecialEvent_field__7VV5j","action":"PopupSpecialEvent_action__OU1nh"};